import {useNavigate} from "react-router-dom";
import {useCallback, useState} from "react";
import {FetchElements, GetCookie} from "../../../../utils/js/request";
import {REQUEST} from "../../../../utils/js/Const";

export const usePatchOrder = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const patchOrder = useCallback((order_guid, goods) => {
        const accessToken = GetCookie("access_token");

        if (!accessToken) {
            console.warn('Нет токена для обновления заказа');
            navigate('/auth');
            return Promise.reject(new Error('No access token'));
        }

        if (!order_guid) {
            return Promise.reject(new Error('No order_guid'));
        }

        const url = `${REQUEST}/api/v1/orders/${order_guid}`;
        setLoading(true);
        setError(null);

        return new Promise((resolve, reject) => {
            FetchElements(
                url,
                "PATCH",
                (responseData) => {
                    setLoading(false);
                    resolve(responseData);
                },
                navigate,
                2,
                () => {},
                (title, message, statusCode) => {
                    const errorObj = {title, message, statusCode};
                    console.error(`${title}: ${message}`);
                    setError(errorObj);
                    setLoading(false);
                    reject(errorObj);
                },
                0,
                {goods}, // тело запроса
                [],
                false
            );
        });
    }, [navigate]);

    return {patchOrder, loading, error};
};